import { RestApi, getIdToken } from "../RestApi/RestApi";
import { API_URL, getCookie } from "../Utils/utils";

export async function getPlans(data = null, operation = null) {
  await getIdToken();
  const url = "/get-plans";
  return await RestApi.get(url, {
    params: data,
  });
}

export async function getPlanApps(data = null, operation = null) {
  await getIdToken();
  const url = "/get-plan-apps";
  return await RestApi.get(url, {
    params: data,
  });
}

export async function getSubscribedPlanApps(data = null, operation = null) {
  await getIdToken();
  const url = "/api/subscribed-plan-apps";
  return await RestApi.get(url, {
    params: data,
  });
}

export async function cancelPlanApp(data = null, operation = null) {
  await getIdToken();
  const url = `/api/cancel-subscribed-plan-apps/${operation}`;
  return await RestApi.post(url, data);
}

export async function buyPlanApps(data = null, operation = null) {
  await getIdToken();
  const url = `/api/buy-plan-apps`;
  return await RestApi.post(url, data);
}